<div class="page-wrapper">

    <app-bees-header></app-bees-header>

    <div class="stricky-header stricked-menu main-menu main-menu-two">
        <div class="sticky-header__content"></div><!-- /.sticky-header__content -->
    </div><!-- /.stricky-header -->



    <!--Main Slider Start-->
    <section class="main-slider">
        <div class="swiper-container thm-swiper__slider">
            <div class="swiper-wrapper">


                <div class="swiper-slide">
                    <div class="main-slider__pattern-bg"
                        style="background-image: url(assets/images/shapes/main-slider-pattern.png);"></div>
                    <div class="main-slider__bg-box">
                        <div class="main-slider__bg"
                            style="background-image: url(assets/images/backgrounds/slider-1-1.jpg);"></div>
                    </div>
                    <div class="main-slider__shape-1"></div>
                    <div class="main-slider__shape-2"></div>
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="main-slider__content">
                                    <h4 class="main-slider__sub-title">Welcome to </h4>
                                    <h2 class="main-slider__title">Thanvika <br> <span> Enterprises</span>
                                        <br>
                                        <!-- <span>Simplified</span>     -->
                                    </h2>
                                    <p class="main-slider__text"> High-quality 2", 3", and 4" thermal paper rolls for
                                        billing machines, <br>POS systems, barcode printers, and retail businesses.
                                        <br>Reliable performance with clear and durable printing results. </p>
                                
                                    <div class="main-slider__map">
                                        <img src="assets/images/shapes/main-slider-map-1.png" alt=""
                                            class="float-bob-y">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="swiper-slide">
                    <div class="main-slider__pattern-bg"
                        style="background-image: url(assets/images/shapes/main-slider-pattern.png);"></div>
                    <div class="main-slider__bg-box">
                        <div class="main-slider__bg"
                            style="background-image: url(assets/images/backgrounds/slider-1-2.jpg);"></div>
                    </div>
                    <div class="main-slider__shape-1"></div>
                    <div class="main-slider__shape-2"></div>
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="main-slider__content">
                                    <!-- <h4 class="main-slider__sub-title">100% Satisfaction</h4> -->
                                    <h2 class="main-slider__title"> Barcode Labels & 
                                        <br> <span>Custom Sticker Printing
                                        </span>
                                    </h2>
                                    <p class="main-slider__text"> From barcode labels and price tags to product stickers and color labels,<br>  we provide customized printing solutions designed to meet your business and branding requirements.

                                    </p>
                                 
                                    <div class="main-slider__map">
                                        <img src="assets/images/shapes/main-slider-map-1.png" alt=""
                                            class="float-bob-y">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="swiper-slide">
                    <div class="main-slider__pattern-bg"
                        style="background-image: url(assets/images/shapes/main-slider-pattern.png);"></div>
                    <div class="main-slider__bg-box">
                        <div class="main-slider__bg"
                            style="background-image: url(assets/images/backgrounds/slider-1-3.jpg);"></div>
                    </div>
                    <div class="main-slider__shape-1"></div>
                    <div class="main-slider__shape-2"></div>
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="main-slider__content">
                                    <!-- <h4 class="main-slider__sub-title">International Logistics</h4> -->
                                    <h2 class="main-slider__title"> Your Trusted Printing & 

                                        <br> <span> Labeling Partner
                                        </span>

                                    </h2>
                                    <p class="main-slider__text"> Thanvika Enterprises delivers premium thermal rolls, barcode labels, price tags, <br> and custom stickers with competitive pricing, excellent quality, and timely delivery across industries.
                                  
                                    <div class="main-slider__map">
                                        <img src="assets/images/shapes/main-slider-map-1.png" alt=""
                                            class="float-bob-y">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="swiper-pagination" id="main-slider-pagination"></div>
            <!-- If we need navigation buttons -->

        </div>
    </section>
    <!--Main Slider End-->



    <!--About Two Start-->
    <section class="about-two">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="about-two__left wow slideInLeft" data-wow-delay="100ms" data-wow-duration="2500ms">
                        <div class="about-two__img-box">
                            <div class="about-two__img">
                                <img src="assets/images/resources/about-two-img-1.jpg" alt="">
                            </div>
                            <div class="about-two__img-two">
                                <img src="assets/images/resources/about-two-img-2.jpg" alt="">
                            </div>
                            <div class="about-two__counter">
                                <div class="shape1"><img src="assets/images/shapes/about-two-shape-1.png" alt="">
                                </div>
                                <div class="count-text-box count-box">
                                    <h2 class="count-text" data-stop="5" data-speed="1500">5</h2>
                                    <span class="plus">+</span>
                                </div>

                                <p>Years Of <br>
                                    Experience</p>
                            </div>
                            <!-- <div class="about-two__shape-2 float-bob-x">
                                <img src="assets/images/shapes/about-two-shape-2.png" alt="">
                            </div> -->
                            <div class="about-two__shape-3">
                                <img src="assets/images/shapes/about-two-shape-3.png" alt="">
                            </div>
                            <!-- <div class="about-two__shape-4 float-bob-y">
                                <img src="assets/images/shapes/about-two-shape-4.png" alt="">
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="about-two__right">
                        <div class="section-title text-left sec-title-animation animation-style2">
                            <div class="section-title__tagline-box">
                                <span class="section-title__tagline-border"></span>
                                <div class="section-title__shape-1">
                                    <i class="fas fa-ship"></i>
                                </div>
                                <h6 class="section-title__tagline">ABOUT US</h6>
                                <span class="section-title__tagline-border"></span>
                                <div class="section-title__shape-2">
                                    <i class="fas fa-ship"></i>
                                </div>
                            </div>
                            <h3 class="section-title__title title-animation"> Welcome to  <span> Thanvika Enterprises</span>

                            </h3>
                        </div>
                        <p class="about-two__text">
                            At Thanvika Enterprises, we are committed to providing high-quality <b> thermal paper rolls,
                                barcode labels, price tags, printed color labels, and customized sticker solutions for
                                businesses of all sizes. </b> With a strong focus on quality, reliability, and customer
                            satisfaction, we have become a trusted supplier for retail stores, supermarkets, textile
                            shops, pharmacies, restaurants, warehouses, logistics companies, and many other industries.
                            <br>
                            We offer premium-quality 2-inch, 3-inch, and 4-inch thermal paper rolls designed for smooth
                            and efficient printing in billing machines, POS systems, and barcode printers. Our products
                            are manufactured to deliver clear print quality, durability, and consistent performance.
                            <br>
                            In addition to thermal paper rolls, we specialize in barcode labels, price tags, color
                            labels, product stickers, branding stickers, and customized label printing solutions.
                            Whether you need labels for inventory management, product identification, retail pricing,
                            shipping, or promotional purposes, we provide solutions tailored to your business
                            requirements.

                        </p>


                        <div class="about-two__btn-and-author-box mb-5">
                              <div class="blog-two__arrow-box">
                                <a routerLink="/about" class="thm-btn">Read More
                                </a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--About Two End-->


    <!-- Blog Two Start -->
    <section class="blog-two">
        <div class="container">
            <div class="section-title text-center sec-title-animation animation-style1">
                <div class="section-title__tagline-box">
                    <span class="section-title__tagline-border"></span>
                    <div class="section-title__shape-1">
                        <i class="fas fa-ship"></i>
                    </div>
                    <h6 class="section-title__tagline"> Our Services</h6>
                    <span class="section-title__tagline-border"></span>
                    <div class="section-title__shape-2">
                        <i class="fas fa-ship"></i>
                    </div>
                </div>
                <h3 class="section-title__title title-animation">Thanvika Enterprises <span> </span>
                </h3>
            </div>
            <div class="row">
                <!-- Blog Two Single Start -->
                <div class="col-xl-3 col-lg-6  wow fadeInLeft" data-wow-delay="100ms">
                    <div class="blog-two__single">
                        <div class="blog-two__img">
                            <img src="assets/images/blog/blog-2-4.jpg" alt="">
                            <div class="blog-two__plus">
                                <a routerLink="/plain-thermal-roll"><i class="icon-plus"></i></a>
                            </div>
                            <div class="blog-two__tag">
                                <a routerLink="/plain-thermal-roll">Plain Paper Roll </a>
                            </div>
                        </div>
                        <div class="blog-two__content">

                            <h3 class="blog-two__title"><a routerLink="/plain-thermal-roll">2 & 3 & 4 Inch Paper Rolls
                                </a></h3>
                            <div class="blog-two__author-and-btn">

                                <div class="blog-two__arrow-box">
                                    <a routerLink="/plain-thermal-roll" class="blog-two__arrow"><span
                                            class="icon-right-arrow"></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Blog Two Single End -->
                <!-- Blog Two Single Start -->
                <div class="col-xl-3 col-lg-6  wow fadeInUp" data-wow-delay="300ms">
                    <div class="blog-two__single">
                        <div class="blog-two__img">
                            <img src="assets/images/blog/blog-2-3.jpg" alt="">
                            <div class="blog-two__plus">
                                <a routerLink="/color-thermal-roll"><i class="icon-plus"></i></a>
                            </div>
                            <div class="blog-two__tag">
                                <a routerLink="/color-thermal-roll">Color Paper Roll </a>
                            </div>
                        </div>
                        <div class="blog-two__content">

                          <h3 class="blog-two__title"><a routerLink="/color-thermal-roll">2 & 3 & 4 Inch Paper Rolls
                                </a></h3>
                            <div class="blog-two__author-and-btn">

                                <div class="blog-two__arrow-box">
                                    <a routerLink="/color-thermal-roll" class="blog-two__arrow"><span
                                            class="icon-right-arrow"></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Blog Two Single End -->
                <!-- Blog Two Single Start -->
                <div class="col-xl-3 col-lg-6  wow fadeInRight" data-wow-delay="500ms">
                    <div class="blog-two__single">
                        <div class="blog-two__img">
                            <img src="assets/images/blog/blog-2-2.jpg" alt="">
                            <div class="blog-two__plus">
                                <a routerLink="/printed-thermal-roll"><i class="icon-plus"></i></a>
                            </div>
                            <div class="blog-two__tag">
                                <a routerLink="/printed-thermal-roll">Printed Paper Roll </a>
                            </div>
                        </div>
                        <div class="blog-two__content">

                           <h3 class="blog-two__title"><a routerLink="/printed-thermal-roll">2 & 3 & 4 Inch Paper Rolls
                                </a></h3>
                            <div class="blog-two__author-and-btn">

                                <div class="blog-two__arrow-box">
                                    <a routerLink="/printed-thermal-roll" class="blog-two__arrow"><span
                                            class="icon-right-arrow"></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Blog Two Single End -->
                <!-- Blog Two Single Start -->
                <div class="col-xl-3 col-lg-6  wow fadeInLeft" data-wow-delay="100ms">
                    <div class="blog-two__single">
                        <div class="blog-two__img">
                            <img src="assets/images/blog/blog-2-1.jpg" alt="">
                            <div class="blog-two__plus">
                                <a routerLink="/stickers"><i class="icon-plus"></i></a>
                            </div>
                            <div class="blog-two__tag">
                              <a routerLink="/stickers"> Label / Stickers </a>
                            </div>
                        </div>
                        <div class="blog-two__content">

                          <h3 class="blog-two__title"><a routerLink="/stickers">Custom Size Available
                                </a></h3>
                            <div class="blog-two__author-and-btn">

                                <div class="blog-two__arrow-box">
                                    <a routerLink="/stickers" class="blog-two__arrow"><span
                                            class="icon-right-arrow"></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Blog Two Single End -->
            </div>
        </div>
    </section>
    <!-- Blog Two End -->






    <!--Why Choose Two Start-->
    <section class="why-choose-two">
        <div class="why-choose-two__pattern"
            style="background-image: url(assets/images/shapes/why-choose-two-pattern.png);"></div>
        <div class="why-choose-two__bg-box">
            <div class="why-choose-two__shape-bg"
                style="background-image: url(assets/images/shapes/why-choose-two-shpae-bg.png);"></div>
        </div>
        <div class="why-choose-two__img reveal">
            <img src="assets/images/resources/why-choose-two-img-1.png" alt="">
        </div>
      
        <div class="container">
            <div class="row">
                <div class="col-xl-8">
                    <div class="why-choose-two__left">
                        <div class="why-choose-two__title-box">
                            <div class="section-title text-left sec-title-animation animation-style1">
                                <div class="section-title__tagline-box">
                                    <span class="section-title__tagline-border"></span>
                                    <div class="section-title__shape-1">
                                        <i class="fas fa-ship"></i>
                                    </div>
                                    <h6 class="section-title__tagline">Why Choose us</h6>
                                    <span class="section-title__tagline-border"></span>
                                    <div class="section-title__shape-2">
                                        <i class="fas fa-ship"></i>
                                    </div>
                                </div>
                                <h3 class="section-title__title title-animation">Reason For Choosing
                                    <span>Thanvika Enterprises</span>
                                </h3>
                            </div>
                            <p class="why-choose-two__text" style=" text-align: justify;">Our mission is to provide
                                cost-effective and innovative printing and labeling solutions that help businesses
                                operate more efficiently while enhancing their professional image.

                                Choose Thanvika Enterprises as your trusted partner for thermal rolls, barcode labels,
                                price tags, color labels, and all kinds of sticker printing solutions. We are dedicated
                                to delivering quality products and exceptional service that exceed customer
                                expectations.</p>
                        </div>
                    

<div class="why-choose-two__point-box">

    <ul class="why-choose-two__point">

        <li>
            <div class="why-choose-two__icon">
              <span>     <i class="fas fa-award"></i></span>   
            </div>
            <div class="why-choose-two__content">
                <h4>Premium Quality Products</h4>
            </div>
        </li>

        <li>
            <div class="why-choose-two__icon">
             <span>      <i class="fas fa-tags"></i></span>   
            </div>
            <div class="why-choose-two__content">
                <h4>Competitive Pricing</h4>
            </div>
        </li>

        <li>
            <div class="why-choose-two__icon">
             <span>      <i class="fas fa-print"></i></span>   
            </div>
            <div class="why-choose-two__content">
                <h4>Customized Printing Solutions</h4>
            </div>
        </li>

    </ul>

    <ul class="why-choose-two__point why-choose-two__point--two">

        <li>
            <div class="why-choose-two__icon">
              <span>  <i class="fas fa-truck"></i></span>   
            </div>
            <div class="why-choose-two__content">
                <h4>On-Time Delivery</h4>
            </div>
        </li>

        <li>
            <div class="why-choose-two__icon">
               <span><i class="fas fa-headset"></i> </span> 
            </div>
            <div class="why-choose-two__content">
                <h4>Dedicated Customer Support</h4>
            </div>
        </li>

        <li>
            <div class="why-choose-two__icon">
         <span>    <i class="fas fa-handshake"></i></span>   
            </div>
            <div class="why-choose-two__content">
                <h4>Trusted Business Relationships</h4>
            </div>
        </li>

    </ul>

</div>

                    
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--Why Choose Two End-->



    <!--Testimonials Two Start -->
    <section class="testimonial-two" >
        <div class="container">
            <div class="section-title text-left sec-title-animation animation-style1">
                <div class="section-title__tagline-box">
                    <span class="section-title__tagline-border"></span>
                    <div class="section-title__shape-1">
                        <i class="fas fa-ship"></i>
                    </div>
                    <h6 class="section-title__tagline"> Client Feedback
                    </h6>
                    <span class="section-title__tagline-border"></span>
                    <div class="section-title__shape-2">
                        <i class="fas fa-ship"></i>
                    </div>
                </div>
                <h3 class="section-title__title title-animation">
                  Feedback
                </h3>
            </div>
        <div class="testimonial-two__middle">
    <div class="testimonial-two__carousel owl-carousel owl-theme">

        <!-- Testimonial 1 -->
        <div class="item">
            <div class="testimonial-two__single">
                <div class="testimonial-two__single-inner">
                    <div class="testimonial-two__shape-1">
                        <img src="assets/images/shapes/testimonial-two-shape-1.png" alt="">
                    </div>
                    <div class="testimonial-two__quote">
                        <i class="fas fa-quote-left"></i>
                    </div>

                    <p class="testimonial-two__text">
                        Thanvika Enterprises provides excellent quality thermal paper rolls
                        with clear printing and long-lasting performance. Delivery is always
                        on time and the quality is consistent.
                    </p>

                    <div class="testimonial-two__client-info">
                        <div class="testimonial-two__client-img">
                            <img src="assets/images/testimonial/customer-1.jpg" alt="">
                        </div>
                        <div class="testimonial-two__client-content">
                            <h3>Thermal Paper Rolls</h3>
                            <p>Retail Store Owner</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Testimonial 2 -->
        <div class="item">
            <div class="testimonial-two__single">
                <div class="testimonial-two__single-inner">
                    <div class="testimonial-two__shape-1">
                        <img src="assets/images/shapes/testimonial-two-shape-1.png" alt="">
                    </div>
                    <div class="testimonial-two__quote">
                        <i class="fas fa-quote-left"></i>
                    </div>

                    <p class="testimonial-two__text">
                        The barcode stickers supplied by Thanvika Enterprises have strong
                        adhesive quality and work perfectly with our barcode printers.
                        Highly recommended.
                    </p>

                    <div class="testimonial-two__client-info">
                        <div class="testimonial-two__client-img">
                            <img src="assets/images/testimonial/customer-2.jpg" alt="">
                        </div>
                        <div class="testimonial-two__client-content">
                            <h3>Barcode Labels</h3>
                            <p>Supermarket Manager</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Testimonial 3 -->
        <div class="item">
            <div class="testimonial-two__single">
                <div class="testimonial-two__single-inner">
                    <div class="testimonial-two__shape-1">
                        <img src="assets/images/shapes/testimonial-two-shape-1.png" alt="">
                    </div>
                    <div class="testimonial-two__quote">
                        <i class="fas fa-quote-left"></i>
                    </div>

                    <p class="testimonial-two__text">
                        We have been using their billing rolls for our supermarket.
                        The paper quality is premium and there are no fading or
                        paper jam issues.
                    </p>

                    <div class="testimonial-two__client-info">
                        <div class="testimonial-two__client-img">
                            <img src="assets/images/testimonial/customer-3.jpg" alt="">
                        </div>
                        <div class="testimonial-two__client-content">
                            <h3>POS Billing Rolls</h3>
                            <p>Department Store</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Testimonial 4 -->
        <div class="item">
            <div class="testimonial-two__single">
                <div class="testimonial-two__single-inner">
                    <div class="testimonial-two__shape-1">
                        <img src="assets/images/shapes/testimonial-two-shape-1.png" alt="">
                    </div>
                    <div class="testimonial-two__quote">
                        <i class="fas fa-quote-left"></i>
                    </div>

                    <p class="testimonial-two__text">
                        The price tags and product labels are printed with excellent clarity.
                        Their products help us maintain a professional retail display.
                    </p>

                    <div class="testimonial-two__client-info">
                        <div class="testimonial-two__client-img">
                            <img src="assets/images/testimonial/customer-4.jpg" alt="">
                        </div>
                        <div class="testimonial-two__client-content">
                            <h3>Price Tags & Labels</h3>
                            <p>Fashion Store</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Testimonial 5 -->
        <div class="item">
            <div class="testimonial-two__single">
                <div class="testimonial-two__single-inner">
                    <div class="testimonial-two__shape-1">
                        <img src="assets/images/shapes/testimonial-two-shape-1.png" alt="">
                    </div>
                    <div class="testimonial-two__quote">
                        <i class="fas fa-quote-left"></i>
                    </div>

                    <p class="testimonial-two__text">
                        Reliable supplier for POS rolls and thermal papers.
                        Competitive pricing, quality products and excellent customer support.
                    </p>

                    <div class="testimonial-two__client-info">
                        <div class="testimonial-two__client-img">
                            <img src="assets/images/testimonial/customer-5.jpg" alt="">
                        </div>
                        <div class="testimonial-two__client-content">
                            <h3>Retail Billing Solutions</h3>
                            <p>Medical Store</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Testimonial 6 -->
        <div class="item">
            <div class="testimonial-two__single">
                <div class="testimonial-two__single-inner">
                    <div class="testimonial-two__shape-1">
                        <img src="assets/images/shapes/testimonial-two-shape-1.png" alt="">
                    </div>
                    <div class="testimonial-two__quote">
                        <i class="fas fa-quote-left"></i>
                    </div>

                    <p class="testimonial-two__text">
                        Thanvika Enterprises delivered customized barcode labels exactly
                        as required. The print quality and adhesive strength are outstanding.
                    </p>

                    <div class="testimonial-two__client-info">
                        <div class="testimonial-two__client-img">
                            <img src="assets/images/testimonial/customer-6.jpg" alt="">
                        </div>
                        <div class="testimonial-two__client-content">
                            <h3>Custom Barcode Stickers</h3>
                            <p>Warehouse Operator</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Testimonial 7 -->
        <div class="item">
            <div class="testimonial-two__single">
                <div class="testimonial-two__single-inner">
                    <div class="testimonial-two__shape-1">
                        <img src="assets/images/shapes/testimonial-two-shape-1.png" alt="">
                    </div>
                    <div class="testimonial-two__quote">
                        <i class="fas fa-quote-left"></i>
                    </div>

                    <p class="testimonial-two__text">
                        Best supplier for thermal rolls, barcode stickers and labels.
                        Consistent quality and fast delivery service every time.
                    </p>

                    <div class="testimonial-two__client-info">
                        <div class="testimonial-two__client-img">
                            <img src="assets/images/testimonial/customer-7.jpg" alt="">
                        </div>
                        <div class="testimonial-two__client-content">
                            <h3>Wholesale Supply</h3>
                            <p>Distributor</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Testimonial 8 -->
        <div class="item">
            <div class="testimonial-two__single">
                <div class="testimonial-two__single-inner">
                    <div class="testimonial-two__shape-1">
                        <img src="assets/images/shapes/testimonial-two-shape-1.png" alt="">
                    </div>
                    <div class="testimonial-two__quote">
                        <i class="fas fa-quote-left"></i>
                    </div>

                    <p class="testimonial-two__text">
                        Professional service, premium products and affordable pricing.
                        Thanvika Enterprises is our trusted partner for all billing and
                        labeling requirements.
                    </p>

                    <div class="testimonial-two__client-info">
                        <div class="testimonial-two__client-img">
                            <img src="assets/images/testimonial/customer-8.jpg" alt="">
                        </div>
                        <div class="testimonial-two__client-content">
                            <h3>Overall Service</h3>
                            <p>Business Owner</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
        </div>
    </section>
    <!--Testimonials Two End -->

    <!--Contact One Start -->
    <section class="contact-one" >
        <div class="contact-one__shape-bg"
            style="background-image: url(assets/images/shapes/contact-one-shape-bg.png);"></div>
        <div class="contact-one__bg-img"
            style="background-image: url(assets/images/backgrounds/contact-one-bg-img.jpg);"></div>
        <div class="container">
            <div class="row">
                <div class="col-xl-6 col-lg-6">
                    <div class="contact-one__left">
                        <div class="contact-one__video-link">
                            <a href="https://youtube.com/shorts/K-RJS8Vcz8g?feature=share" class="video-popup">
                                <div class="contact-one__video-icon">
                                    <span class="fa fa-play"></span>
                                    <i class="ripple"></i>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6">
                    <div class="contact-one__right wow slideInRight" data-wow-delay="100ms" data-wow-duration="2500ms">
                        <div class="contact-one__content">
                            <p class="contact-one__tagline">Please feel free to</p>
                            <h2 class="contact-one__title">Contact Us </h2>
                            <form class="contact-one__form contact-form-validated"
                                action="https://dreamlayout.mnsithub.com/html/tanspot/main-html/assets/inc/sendemail.php"
                                method="POST">
                                <div class="contact-one__content-box">
                                    <div class="contact-one__input-box">
                                        <input type="text" placeholder="Your Name" name="name" required>
                                    </div>
                                    <div class="contact-one__input-box">
                                        <input type="email" placeholder="Email Address" name="email" required>
                                    </div>
                                    <div class="contact-one__input-box">
                                        <input type="text" placeholder="Phone Number" name="phone" required>
                                    </div>
                                    <div class="contact-one__input-box">
                                        <input type="text" placeholder="Message" name="Message">
                                    </div>
                                </div>

                                <div class="contact-one__content-bottom">
                                    <button type="submit" class="thm-btn">Submit</button>

                                </div>
                                <div class="result"></div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--Contact One End -->

    <!-- Team Two Start -->
    <section class="team-two" style="display: none;">
        <div class="container">
            <div class="section-title text-center sec-title-animation animation-style1">
                <div class="section-title__tagline-box">
                    <span class="section-title__tagline-border"></span>
                    <div class="section-title__shape-1">
                        <i class="fas fa-ship"></i>
                    </div>
                    <h6 class="section-title__tagline">Our Team Members</h6>
                    <span class="section-title__tagline-border"></span>
                    <div class="section-title__shape-2">
                        <i class="fas fa-ship"></i>
                    </div>
                </div>
                <h3 class="section-title__title title-animation">Board of Directors

                </h3>
            </div>
            <div class="team-two__carousel owl-carousel owl-theme">
                <!-- Team Two Single Start -->

                <!-- Team Two Single Start -->
                <div class="item">
                    <div class="team-two__single">
                        <div class="team-two__img-box">
                            <div class="team-two__img">
                                <img src="assets/images/team/team-2-2.jpg" alt="">
                                <div class="team-two__social">
                                    <a href="team-details.html"><i class="fab fa-facebook-f"></i></a>
                                    <a href="team-details.html"><i class="fab fa-twitter"></i></a>
                                    <a href="team-details.html"><i class="fab fa-pinterest-p"></i></a>
                                    <a href="team-details.html"><i class="fab fa-instagram"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="team-two__content">
                            <h3 class="team-two__name"><a href="team-details.html"> Adv. K.j.Thomas</a></h3>
                            <p class="team-two__sub-title"> M.com. Ll.b., cert. Arb& med</p>
                        </div>
                    </div>
                </div>
                <!-- Team Two Single End -->

                <!-- Team Two Single Start -->
                <div class="item">
                    <div class="team-two__single">
                        <div class="team-two__img-box">
                            <div class="team-two__img">
                                <img src="assets/images/team/team-2-4.jpg" alt="">
                                <div class="team-two__social">
                                    <a href="team-details.html"><i class="fab fa-facebook-f"></i></a>
                                    <a href="team-details.html"><i class="fab fa-twitter"></i></a>
                                    <a href="team-details.html"><i class="fab fa-pinterest-p"></i></a>
                                    <a href="team-details.html"><i class="fab fa-instagram"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="team-two__content">
                            <h3 class="team-two__name"><a href="team-details.html"> Adv. K.Venugopal</a></h3>
                            <p class="team-two__sub-title"> Msw., mba,Llm</p>
                        </div>
                    </div>
                </div>
                <!-- Team Two Single End -->



                <!-- Team Two Single End -->

                <!-- Team Two Single Start -->
                <div class="item">
                    <div class="team-two__single">
                        <div class="team-two__img-box">
                            <div class="team-two__img">
                                <img src="assets/images/team/team-2-3.jpg" alt="">
                                <div class="team-two__social">
                                    <a href="team-details.html"><i class="fab fa-facebook-f"></i></a>
                                    <a href="team-details.html"><i class="fab fa-twitter"></i></a>
                                    <a href="team-details.html"><i class="fab fa-pinterest-p"></i></a>
                                    <a href="team-details.html"><i class="fab fa-instagram"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="team-two__content">
                            <h3 class="team-two__name"><a href="team-details.html">Adv. K.Pradeep Kumar</a></h3>
                            <p class="team-two__sub-title">Bsc. Ll.b, mbl </p>
                        </div>
                    </div>
                </div>


                <div class="item">
                    <div class="team-two__single">
                        <div class="team-two__img-box">
                            <div class="team-two__img">
                                <img src="assets/images/team/team-2-1.jpg" alt="">
                                <div class="team-two__social">
                                    <a href="team-details.html"><i class="fab fa-facebook-f"></i></a>
                                    <a href="team-details.html"><i class="fab fa-twitter"></i></a>
                                    <a href="team-details.html"><i class="fab fa-pinterest-p"></i></a>
                                    <a href="team-details.html"><i class="fab fa-instagram"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="team-two__content">
                            <h3 class="team-two__name"><a href="team-details.html"> Adv. V.Gerosh Kumar</a></h3>
                            <p class="team-two__sub-title">B.tech,mca, Fis, Llm</p>
                        </div>
                    </div>
                </div>
                <!-- Team Two Single End -->

                <!-- Team Two Single Start -->

                <!-- Team Two Single End -->
            </div>
        </div>
    </section>
    <!-- Team Two End -->

 

    <app-bees-footer></app-bees-footer>

</div><!-- /.page-wrapper -->